import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5e3e3377")
const _hoisted_1 = { class: "access-denied-wrapper" }
const _hoisted_2 = {
  key: 0,
  ref: "canvas"
}
const _hoisted_3 = { class: "overlay" }
const _hoisted_4 = {
  class: "overlay-inner",
  ref: "overlayInner"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "auth-switch" }
const _hoisted_9 = { class: "auth-switch-text" }
const _hoisted_10 = ["href"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.asset)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-holder",
          style: _normalizeStyle({ 'background-image': `url(${_ctx.newImageUrl})` }),
          ref: "imageHolder"
        }, [
          (_ctx.asset.assetType !== this.isModels)
            ? (_openBlock(), _createElementBlock("canvas", _hoisted_2, null, 512))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t("modals.access_denied.title")), 1),
              _createElementVNode("p", { innerHTML: _ctx.premiumText }, null, 8, _hoisted_5),
              (_ctx.isUserAuth)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "v1-button-5",
                    href: _ctx.getPremiumLinkPath
                  }, _toDisplayString(_ctx.$t("buttons.get_premium")), 9, _hoisted_6))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("a", {
                      class: "v1-button-5",
                      href: _ctx.getSignUpLinkPath
                    }, _toDisplayString(_ctx.$t("buttons.create_account")), 9, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("modals.access_denied.already_have_account")), 1),
                      _createElementVNode("a", {
                        class: "auth-switch-link",
                        href: _ctx.getSignInLinkPath
                      }, _toDisplayString(_ctx.$t("buttons.sign_in_here")), 9, _hoisted_10)
                    ])
                  ], 64))
            ], 512)
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}